import React, { useState, useEffect, useRef } from 'react';
import './Test.css';
import { useAuth } from '../context/AuthContext';
import { useAppTranslation } from "./TranslationContext";
import { useParams, Link } from "react-router-dom";

export const Test = () => {
  const { user, userKursData, setUserKursData } = useAuth();
  const { kursId, id, themes, nextLessonId } = useParams();
  const { t } = useAppTranslation();
  const lang = localStorage.getItem('language') || 'uz';

  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [totalTime, setTotalTime] = useState(180);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [minScore, setMinScore] = useState(0);
  const [currentTartib, setCurrentTartib] = useState(0);

  const answersRef = useRef([]);
  const loadedRef = useRef(false);

  // Загрузка данных
  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    const loadTestData = async () => {
      try {
        // 1. Получаем testCount и minScore
        const countRes = await fetch(`https://api.rasulova-academy.uz/api/kurs-mavzulari/${id}/`);
        const countData = await countRes.json();
        console.log(countData)
        const testCount = countData.test_soni;
        setMinScore(countData.test_min_soni);
        setCurrentTartib(countData.tartib);

        // 2. Получаем список тестов
        const testsRes = await fetch(`https://api.rasulova-academy.uz/api/kurs-mavzu-test/?mavzu=${id}`);
        const testsData = await testsRes.json();

        if (!testsData.length) {
          setQuestions([]);
          setLoading(false);
          return;
        }

        // Перемешиваем и выбираем нужное количество
        const shuffled = [...testsData].sort(() => 0.5 - Math.random());
        const selectedTests = shuffled.slice(0, testCount);

        // Генератор ответов
        const makeAnswers = (item) => ({
          uz: [
            { text: item.V1_uz, isCorrect: true },
            { text: item.V2_uz, isCorrect: false },
            { text: item.V3_uz, isCorrect: false },
            { text: item.V4_uz, isCorrect: false },
          ],
          ru: [
            { text: item.V1_ru, isCorrect: true },
            { text: item.V2_ru, isCorrect: false },
            { text: item.V3_ru, isCorrect: false },
            { text: item.V4_ru, isCorrect: false },
          ],
          en: [
            { text: item.V1_en, isCorrect: true },
            { text: item.V2_en, isCorrect: false },
            { text: item.V3_en, isCorrect: false },
            { text: item.V4_en, isCorrect: false },
          ]
        });

        // Формируем вопросы
        const preparedQuestions = selectedTests.map(item => ({
          question: item[`test_savol_${lang}`],
          answers: makeAnswers(item)[lang].sort(() => 0.5 - Math.random()),
          testId: item.id,
        }));

        setQuestions(preparedQuestions);
        setTotalTime(testCount * 60);
        setLoading(false);

      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadTestData();
  }, [kursId, id, lang]);

  // Таймер
  useEffect(() => {
    if (finished) return;
    const timer = setInterval(() => {
      setTotalTime(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleFinish();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [finished]);

  const handleNext = () => {
    const currentQuestionObj = questions[current];
    const selectedAnswer = currentQuestionObj.answers[selected];
    const isCorrect = selectedAnswer?.isCorrect;

    if (isCorrect) {
      setScore(prev => prev + 1);
    }

    answersRef.current.push({
      user: user?.id,
      test: currentQuestionObj.testId,
      V: selectedAnswer?.text,
      javob_xolati: isCorrect,
    });

    setSelected(null);

    if (current + 1 < questions.length) {
      setCurrent(prev => prev + 1);
    } else {
      handleFinish();
    }
  };

  const handleFinish = async () => {
    setFinished(true);

    // Отправляем ответы
    for (const answer of answersRef.current) {
      try {
        const response = await fetch("https://api.rasulova-academy.uz/api/kurs-mavzu-test-natija/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(answer),
        });
        if (!response.ok) throw new Error(`Ошибка отправки ответа: ${response.status}`);
      } catch (err) {
        console.error(err.message);
      }
    }

    // Сохраняем прогресс
    if (score >= minScore) {
      try {
        let kursData = userKursData;
        console.log(kursData)
        
        if (!kursData) {
          const res = await fetch(`https://api.rasulova-academy.uz/api/user-kurs/?user=${user?.id}&kurs=${kursId}`);
          const data = await res.json();
          kursData = data[0];
        }
        if (!kursData) throw new Error("Нет данных о курсе");
        console.log(parseInt(kursData.mavzu) === parseInt(currentTartib));
        console.log(currentTartib);
        if(parseInt(kursData.mavzu) === parseInt(currentTartib)) {
        const patchRes = await fetch(`https://api.rasulova-academy.uz/api/user-kurs/${kursData.id}/`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user: user?.id,
            kurs: parseInt(kursId),
            mavzu: parseInt(currentTartib) + 1,
          }),
        });
        if (!patchRes.ok) throw new Error("Ошибка сохранения прогресса");

        setUserKursData({
          ...kursData,
          mavzu: parseInt(currentTartib) + 1,
        });
        }

      } catch (err) {
        console.error(err.message);
      }
    }
  };

  const handleLinks = (score) => {
    const minPassed = score >= minScore;
    const currentId = parseInt(currentTartib);
    const themesId = parseInt(themes);
    console.log(currentId)
    return (
      <div className='test__over__links'>
        <Link to={`/lesson/${kursId}/${id}`} className='register__btn btn__passive'>{t('backLesson')}</Link>
        {minPassed && currentId !== themesId && (
          <Link to={`/lesson/${kursId}/${nextLessonId}`} className='register__btn'>{t('forward')}</Link>
        )}
        {minPassed && userKursData.mavzu > themesId && currentId === themesId && (
          <Link to={`/Yakuniy/${kursId}`} className='register__btn'>{t('testFinish')}</Link>
        )}
      </div>
    );
  };

  const minutes = Math.floor(totalTime / 60);
  const seconds = totalTime % 60;
  const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  const progress = (current / questions.length) * 100;

  if (loading) return <p className='container'>Yuklanmoqda...</p>;
  if (error) return <p className='container' style={{ color: 'red' }}>Xatolik: {error}</p>;
  if (questions.length === 0) return <p className='container'>Savollar topilmadi.</p>;

  if (finished) {
    return (
      <div className="container">
        <div className="quiz-container quiz-container-result">
          <h2>{t('result')} {Math.round(score / questions.length * 100)}%</h2>
          <p>{t('answer1')} {score} {t('answer2')} {questions.length} {t('answer3')}</p>
          {handleLinks(score)}
          {totalTime === 0 && <p style={{ color: 'red' }}>{t('timeOver')}</p>}
        </div>
      </div>
    );
  }

  const currentQuestion = questions[current];

  return (
    <div className="container">
      <div className="quiz-container">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>

        <div className="timer">{formattedTime} {t('left')}</div>

        <h2 dangerouslySetInnerHTML={{ __html: currentQuestion.question }} />
        <div className="answers">
          {currentQuestion.answers.map((answer, idx) => (
            <button
              key={idx}
              className={`answer-button ${selected === idx ? 'selected' : ''}`}
              onClick={() => setSelected(idx)}
              dangerouslySetInnerHTML={{ __html: answer.text }}
            />
          ))}
        </div>

        <button className="next-button" onClick={handleNext} disabled={selected === null}>
          {current === questions.length - 1 ? t('finish') : t('next')}
        </button>
      </div>
    </div>
  );
};
